var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4,10.4l0.8-2.5h3.6c0.8,0.2,2.4,2.2,2.4,2.2c0.4,0.1,3.8,0.4,3.8,0.4c1.5,0.2,1.2,1,1.2,1 c0,1.7,0.7,1.6,0.7,1.6v1.6h-1.7c0.6-2.2-1.7-2.4-1.7-2.4c-2.2,0-2,2.4-2,2.4H7.8C8.1,12.5,6,12.4,6,12.4c-2.1,0-2,2.4-2,2.4 l-3-0.4v-1c0.6,0,0.5-0.4,0.5-0.4v-2.6L10.4,10.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "14.8,8.3 16.7,10.4 16.7,10.7 11.8,10.7 12.2,8.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 11.4,
    style: {
      fill: "#000"
    },
    width: 1.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 14,
    style: {
      fill: "#000"
    },
    width: 8.3,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.2,14.4c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7S4.2,13.5,4.2,14.4z M5.4,14.4 C5.4,14.3,5.4,14.3,5.4,14.4c0-0.4,0.3-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1S5.4,14.6,5.4,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.8,14.4c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7S17.8,13.5,17.8,14.4z M19,14.4 C19,14.3,19,14.3,19,14.4c0-0.4,0.3-0.5,0.5-0.5s0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.3,0-0.4-0.1C19,14.7,19,14.6,19,14.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.9f2c5a2a4f369e86340219d504fc66b2.svg";
export { ForwardRef as ReactComponent };